<template>
  <div class="sd-base-con" :class="{ 'blur-con': showLoadingScreen }">
    <div class="sd-header" :class="{ 'with-logo': showMainLogo }">
      <div class="sd-header-logo-con" v-if="showMainLogo" @click="goTo('HomePage')">
        <img
          width="150"
          height="90"
          alt="tpbf logo"
          :src="require('@/assets/tpbf/TPBF-brand-3.png')"
        />
      </div>
      <slot name="header"></slot>
    </div>
    <div class="notification__con">
      <base-notification
        :class="{ active: notification.show }"
      ></base-notification>
    </div>
    <div
      class="sd-main-con"
      :class="{
        'overflow-hidden': overflowHidden == true,
        'has-footer-slot': hasFooterSlot,
        'auto-height': autoHeight,
        'hide-footer': hideFooter,
        'hide-footnote': hideFootNote,
        'bg-dark': darkBg
      }"
    >
      <div class="sd-main-body">
        <slot name="body"></slot>
      </div>
    </div>
    <div id="contact-us"
      class="sd-footer"
      :class="{ 'auto': freeFooter }">
      <div class="inner-container">
        <div class="inner-logo">
          <img :src="require('@/assets/tpbf/SEAL-02.png')" alt="TPBF logo" width="50" height="50"/>
        </div>
        <div class="inner-wrapper">
          <div class="inner">
            <div class="links">
              <!-- <div class="link">
                <span class="link-title">Contact Us</span>
                <span>The Philippines By Foot</span>
                <small>community@thephilippinesbyfoot.com</small>
              </div> -->
              <div class="link">
                <!-- <span class="link-title">Navigation</span> -->
                <router-link to="/about-us">About</router-link>
                <router-link to="/events">Events</router-link>
                <router-link to="/contact">Contact Us</router-link>
                <a target="_blank" href="https://www.instagram.com/thephilippinesbyfoot?igsh=MXdqZzJhZWFuczB0Zg%3D%3D&utm_source=qr">Connect</a>
              </div>
              <!-- <div class="link">
                <span class="link-title">Socials</span>
                <div class="media-icons">
                  <a href="https://www.facebook.com/profile.php?id=61589420352773" target="_blank">
                    <img src="@/assets/tpbf/fb-icon.png" alt="" />
                  </a>
                  <a href="https://www.instagram.com/thephilippinesbyfoot?igsh=MXdqZzJhZWFuczB0Zg%3D%3D&utm_source=qr" target="_blank">
                    <img src="@/assets/tpbf/instagram-icon.png" alt="" />
                  </a>
                </div>
              </div> -->
            </div>
            <div class="footer-brands">
              <img src="@/assets/tpbf/TPBF-brand-3-blue.png" alt="" />
              <!-- <img src="@/assets/tpbf/SEAL-01.png" alt=""> -->
              <img src="@/assets/tpbf/TPBF-brand-2.png" alt="" />
              <img src="@/assets/tpbf/DOT-logo.png" alt="">
              <img src="@/assets/tpbf/TPBF-brand-1.png" alt="" />
            </div>
          </div>
          <div class="legal">
            <div class="copyright">
              © Copyright {{ thisYear }}, The Philippines By Foot. All rights reserved.
            </div>
            <div class="legal-info">
              <router-link to="/privacy-policy">Privacy Policy</router-link>
              <router-link to="/terms-of-use">Terms Of Use</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sd-base-loading-con" v-if="showLoadingScreen">
    <div class="sd-loading-con">
      <div class="dot-overtaking"></div>
      <p class="body-2-regular bold loading-text secondary-color-60">
        Loading ...
      </p>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import router from "@/router";

export default {
  name: "LayoutVariantTwo",
  props: {
    showLoadingScreen: {
      type: Boolean,
      default: false,
    },
    showMainLogo: {
      type: Boolean,
      default: false,
    },
    overflowHidden: {
      type: Boolean,
      default: false,
    },
    freeFooter: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    footerWhite: {
      type: Boolean,
      default: false,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
    hideFootNote: {
      type: Boolean,
      default: false,
    },
    darkBg: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const store = useStore();
    const notification = computed(() => store.state.notification);
    const hasHeaderSlot = computed(() => !!context.slots.header);
    const hasFooterSlot = computed(() => !!context.slots.footer);
    const thisYear = computed(() => {
      const date = new Date();
      return date.getFullYear();
    });

    const goToTermsOfUse = () => router.push({ name: "TermsOfUse" });
    const goToPrivacyPolicy = () => router.push({ name: "PrivacyPolicy" });

    return {
      store,
      notification,
      hasHeaderSlot,
      hasFooterSlot,
      thisYear,
      goToTermsOfUse,
      goToPrivacyPolicy,
    };
  },
};
</script>

<style scoped lang="scss">
.sd-base-con {
  background: $white;
  &.blur-con {
    filter: blur(2px);
    -webkit-filter: blur(2px);
    -moz-filter: blur(2px);
    -o-filter: blur(2px);
  }
}

.sd-header {
  width: 100%;
  height: auto !important;
  position: sticky;
  top: 0;
  z-index: 2;

  &.with-logo {
    position: relative;
    margin-top: -36px;
  }

  .sd-header-logo-con {
    position: relative;
    width: fit-content;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 99999;
    top: 48px;
    pointer-events: none;
    img {
      object-fit: contain;
    }
  }
}

.sd-main-con {
  width: 100%;
  position: relative;
  flex: 3;
  min-height: 100%;
  &.bg-dark {
    background: $secondary-color-30;
  }

  &.overflow-hidden {
    overflow: hidden;
  }

  &.auto-height {
    height: auto !important;
  }

  &.has-footer-slot {
    &:not(.hide-footer) {
      height: auto !important;
      padding-bottom: 56px;
    }
  }

  &.hide-footnote {
    height: 100% !important;
    .sd-main-body {
      height: 100% !important;
    }
    & + .sd-footer {
      display: none !important;
      padding: 0 !important;
    }
  }
}

.sd-main-body {
  width: 100%;
  flex: 3;
}

.body-footnote {
  background: $primary-color-100;
  padding: 24px;
  color: $white;
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: auto;
  position: relative;
  &.invisible {
    display: none !important;
  }
  .footnote-tnc {
    display: flex;
    gap: 48px;
    align-items: center;

    .tnc-item {
      font-weight: bold;
      color: $white;
      cursor: pointer;
      text-decoration: none;

      & + .tnc-item {
        padding-left: 16px;
        border-left: 1px solid $white;
      }
    }
  }
}
.footer-brands {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: auto;
  max-width: 350px;
  gap: 24px;
  img {
    min-height: 55px;
    height: 55px;
  }
}
.media-icons {
  display: flex;
  align-items: center;
  gap: 6px;
  img {
    width: 35px;
    height: 35px;
  }
}
.sd-footer {
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 20px;
  background-color: #f5f5f5;
  border-top: 1px solid $primary-color-10;
  z-index: 1;

  &.auto {
    height: auto !important;
  }
}
.inner-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .inner-logo {
    width: 100%;
    max-width: 250px;
    margin-inline: auto;
    img {
      width: 100%;
      max-width: 220px;
      height: auto;
      margin-inline: auto;
    }
  }
  .inner-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}
.copyright {
  font-size: 12px;
  line-height: 22px;
}
.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;

  .links {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    text-align: left;
    gap: 32px;
    margin-top: 10px;
    color: $secondary-color-80;
    flex-wrap: wrap;
    flex: 1;
    .link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      .link-title {
        font-weight: 700;
        text-transform: uppercase;
        white-space: nowrap;
      }
    }

    a {
      color: $secondary-color-80;
      margin: 0;
      text-decoration: none;
    }
  }

  img {
    display: block;
    max-height: 50px;
    object-fit: contain;
    object-position: left;
  }
}
.notification__con {
  min-width: 288px;
  position: fixed;
  left: 50%;
  top: 56px;
  transform: translateX(-50%);
  z-index: 100000;
  pointer-events: none;
  width: 100%;

  .notification {
    width: 100%;
    margin: 0 auto;
    opacity: 0;
    transition: all 0.5s;

    &.active {
      opacity: 100%;
    }
  }
}

.sd-base-loading-con {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  .sd-loading-con {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .loading-text {
      margin-top: 40px;
    }
  }
}

.dot-overtaking {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: transparent;
  color: $primary-color-70;
  margin: -1px 0;
  box-shadow: 0 -20px 0 0;
  animation: dotOvertaking 2s infinite cubic-bezier(0.2, 0.6, 0.8, 0.2);
}

.dot-overtaking::before,
.dot-overtaking::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: transparent;
  color: $primary-color-60;
  box-shadow: 0 -20px 0 0;
}

.dot-overtaking::after {
  color: $primary-color-50;
}

.dot-overtaking::before {
  animation: dotOvertaking 2s infinite cubic-bezier(0.2, 0.6, 0.8, 0.2);
  animation-delay: 0.3s;
}

.dot-overtaking::after {
  animation: dotOvertaking 1.5s infinite cubic-bezier(0.2, 0.6, 0.8, 0.2);
  animation-delay: 0.6s;
}

@keyframes dotOvertaking {
  0% {
    transform: rotateZ(0deg);
  }

  100% {
    transform: rotateZ(360deg);
  }
}
.legal {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.legal-info {
  display: flex;
  justify-content: center;
  gap: 32px;
  align-items: center;
  font-weight: 500;
}
@media (min-width: 672px) {
  .sd-main-con,
  .sd-header,
  .notification__con,
  .sd-footer {
    max-width: 100%;
  }
  .legal {
    flex-wrap: wrap;
    align-items: baseline;
  }
  .sd-main-con {
    &.has-footer-slot {
      &:not(.hide-footer) {
        height: auto !important;
        padding-bottom: 0px !important;
      }
    }
  }

  .body-footnote {
    flex-direction: row;
    padding: 24px 7% !important;

    .footnote-tnc {
      gap: 24px;
    }
  }
  .sd-footer {
    padding-inline: 4% !important;
  }
  .inner-container {
    flex-direction: row;
  }
  .inner {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    img {
      object-position: right !important;
    }
  }
  .links {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    .link {
      align-items: flex-start !important;
      justify-content: flex-start !important;
    }
  }
  .footer-brands {
    justify-content: center;
    max-width: 100% !important;
    gap: 16px;
  }
}

@media (min-width: 671px) and (max-width: 1024px){
  .inner {
    flex-direction: column !important;
  }
  .footer-brands {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: flex-start;
  }
}
</style>
